import { ARTICULATION_TYPES, CREDIT_TYPES } from "common/model/creditType";
import { isEmpty, isArray } from "lodash";

export const getTotalCreditPoints = (creditItem) => {
  if (!creditItem) {
    return 0;
  }
  if (creditItem.arrangements) {
    // Case for Articulation
    return creditItem.arrangements.reduce(
      (total, arrangement) =>
        total + arrangement.specified + arrangement.unspecified,
      0,
    );
  } else if (creditItem.subjects) {
    // Case for Precedent
    return creditItem.subjects.reduce(
      (total, subject) => total + subject.creditPoints,
      0,
    );
  }
};

export const isCreditItemExistsInBookmarks = (
  creditBookMarks,
  creditItemID,
  creditType,
) => {
  if (!creditBookMarks || creditBookMarks.length === 0) {
    return false;
  }
  return creditBookMarks.some((creditItem) => {
    return (
      creditItem.creditItemID === creditItemID &&
      creditItem.creditType === creditType
    );
  });
};

export const isArticulation = (creditType) => {
  switch (creditType) {
    case CREDIT_TYPES.ARTICULATION:
    case ARTICULATION_TYPES.INTERNAL:
    case ARTICULATION_TYPES.EXTERNAL:
    case ARTICULATION_TYPES.OFFSHORE:
      return true;
    default:
      return false;
  }
};

export const isPrecedent = (creditType) => {
  return CREDIT_TYPES.PRECEDENT === creditType;
};

export const extractComparableSourceString = (item) => {
  let credentials = [];
  if (item.grouped) {
    if (isArray(item.grouped) && !isEmpty(item.grouped)) {
      // because this is same across all items
      credentials = item.grouped[0] && item.grouped[0].credentials;
    }
  } else {
    credentials = item.credentials;
  }
  const extractedString = credentials
    .map((c) => {
      if (c.data) {
        return c.data.unitName || "";
      } else {
        return "";
      }
    })
    .join(" ");
  return extractedString;
};

export const generalCreditSortOrder = (aItem, bItem) => {
  if (isEmpty(aItem) || isEmpty(bItem)) {
    console.error("empty:", aItem, bItem);
    return 0;
  }

  let applies = false;

  if (isArticulation(aItem.type) && isPrecedent(bItem.type)) {
    return -1;
  }
  if (isPrecedent(aItem.type) && isArticulation(bItem.type)) {
    return 1;
  }
  const aPoints = getTotalCreditPoints(aItem);
  const bPoints = getTotalCreditPoints(bItem);

  if (isArticulation(aItem.type) && isArticulation(bItem.type)) {
    if (aItem.guaranteedEntry && bItem.guaranteedEntry) {
      // Guaranteed entry pathways with zero credit points
      if (aPoints === 0 && bPoints === 0) {
        return aItem.course.name.localeCompare(bItem.course.name);
      } else if (aPoints === 0) {
        return -1;
      } else if (bPoints === 0) {
        return 1;
      } else {
        // Guaranteed entry pathways with highest credit points
        if (aPoints === bPoints) {
          return aItem.course.name.localeCompare(bItem.course.name);
        }
        return aPoints > bPoints ? -1 : 1;
      }
    } else if (aItem.guaranteedEntry) {
      return -1;
    } else if (bItem.guaranteedEntry) {
      return 1;
    }
  }

  // Normal pathways with highest credit points
  if (aPoints === bPoints) {
    return extractComparableSourceString(aItem).localeCompare(
      extractComparableSourceString(bItem),
    );
  }
  return aPoints > bPoints ? -1 : 1;
};
